/** * * Asynchronously loads the component for
PaymentHistory
* */ import { lazyLoad } from "utils/loadable";
export const PaymentHistory = lazyLoad(
  () => import("./index"),
  (module) => module.PaymentHistory
);
